module.exports = __webpack_public_path__ + "static/media/logo.a8ebe9a3.svg";